import { makeStyles } from "@material-ui/core/index.js";

export default makeStyles((theme) => ({
    mainContainer: {
        position: 'fixed',
        width: '80%',
        alignSelf: 'center',
        left: '50%',
        overflow: 'auto',
        transform: 'translate(-50%, 0%)',
        zIndex: 51,
        height: 'calc(100%)',
        [theme.breakpoints.down('md')]: {
            width: '90%',
        }
    },
    overlay: {
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100vw',
        height: '100%',
        minHeight: '100vh',
        backgroundColor: '#e2e2e2',
        opacity: 0.8,
        zIndex: 50,
    },
    overlay2: {
        position: 'absolute',
        height: '100%',
        display: 'none',
        width: '100%',
        backgroundColor: '#e2e2e2',
        opacity: 0.6,
        zIndex: 50,
    },
    profile: {
        margin: 'auto',
        marginTop: '80px',
        marginBottom: '20px',
        width: '98%',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0px 0px 8px #aaaaaa',
    },
    avatar: {
        width: '15vw',
        height: '15vw',
        backgroundColor: '#e2e2e2',
        minHeight: '80px',
        minWidth: '80px',
        maxHeight: '200px',
        maxWidth: '200px',
        border: '2px solid #cccccc',
    },
    username: {
        position: 'absolute',
        fontFamily: 'Cabin',
        fontSize: '30px',
        fontWeight: '500',
        color: '#282828',
        top: '70%',
        left: '100%',
        letterSpacing: '2px',
        marginLeft: '16px',
        transform: 'translate(0%,00%)',
        [theme.breakpoints.down('sm')]: {
            textShadow: '0px 1px 6px #e2e2e2',
            fontSize: '26px',
            letterSpacing: '1.6px',
        },
        [theme.breakpoints.down('xs')]: {
            textShadow: '0px 1px 4px #e2e2e2',
            marginLeft: '8px',
            fontSize: '22px',
            letterSpacing: '1.4px',
        },
    },
    cover: {
        position: 'relative',
        top: 0,
        left: 0,
        backgroundColor: '#e2e2e2',
        width: '100%',
        height: '35vw',
        borderRadius: '4px',
        border: '1px solid #cccccc',
        minHeight: '100px',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'flex-start',
        [theme.breakpoints.down('sm')]: {
            height: '40vw',
            fontSize: '25vh',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '20vh',
        },
    },
    coverImg: {
        borderRadius: '4px',
        width: '100%',
        backgroundColor: '#e2e2e2',
        height: '100%',
        objectFit: 'cover',
    },
    editBtn: {
        float: 'right',
        fontSize: '14px',
        display: 'inline',
        color: '#888888',
        cursor: 'pointer',
        marginRight: '10px',
    },
    container: {
        top: '100%',
        left: '2vw',
        position: 'absolute',
        display: 'flex',
        alignItems: 'flex-end',
        transform: 'translate(0%,-70%)',
    },
    info: {
        display: 'flex',
        width: '100%',
        boxSizing: 'border-box',
        border: '1px solid #cccccc',
        borderRadius: '4px',
        paddingBottom: '10px',
        boxSizing: 'border-box',
        backgroundColor: '#e8e8e8',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    },
    mainInfo: {
        display: 'flex',
        flexDirection: 'column',
        padding: '4px 8px',
        width: '30%',
        boxSizing: 'border-box',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '4px 4px',
        },
    },
    otherInfo: {
        display: 'flex',
        width: '70%',
        flexDirection: 'column',
        padding: '4px 8px',
        boxSizing: 'border-box',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
        [theme.breakpoints.down('xs')]: {
            padding: '4px 4px',
        },
    },
    space: {
        height: '5vw',
        width: '100%',
        backgroundColor: '#e2e2e2',
        [theme.breakpoints.down('sm')]: {
            height: '7vw',
        },
        [theme.breakpoints.down('xs')]: {
            height: '12vw',
        },
    },
    heading: {
        padding: '6px',
        fontWeight: '500',
        color: '#282828',
        boxSizing: 'border-box',
        fontSize: '15px',
        paddingLeft: '16px',
        [theme.breakpoints.down('xs')]: {
            fontSize: '14px',
        },
    },
    content: {
        boxSizing: 'border-box',
        fontSize: '15px',
        height: 'fit-content',
        minHeight: '30px',
        margin: '4px 12px 8px 12px',
        border: '1px solid #cccccc',
        borderRadius: '4px',
        padding: '6px 10px',
        color: '#383838',
        letterSpacing: '0.4px',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: '#f2f2f2',
        
        overflowY: 'scroll',
        [theme.breakpoints.down('xs')]: {
            fontSize: '14px',
        },
    },
    aboutMe: {
        flexGrow: 1,
        color: '#484848',
        minHeight: '150px',
        margin: '4px 12px 8px 12px',
        wordWrap: 'break-word',
        overflowY: 'auto',
        whiteSpace: 'pre-line',
    },
    infoCouple: {
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    },
    infoItem: {
        width: '100%',
        padding: '2px 0px',
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        },
    },
    statusDiv: {
        padding: '2px 0px',
    },
    aboutDiv: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: '2px 0px',
    },
    noProfile: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        fontSize: '26px',
        letterSpacing: '0.6px',
        fontWeight: '500',
        color: '#585858',
        transform: 'translate(-50%, -50%)',
        boxSizing: 'border-box',
        height: '80px',
        width: '300px',
        border: '1px solid #cccccc',
        display: 'flex',
        zIndex: 10,
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: '50%',
        backgroundColor: '#e2e2e2',
        [theme.breakpoints.down('xs')]: {
            width: '150px',
            fontSize: '18px',
            height: '40px',
        },
    },
    editAvatarDiv: {
        position: 'absolute',
        top: '0%',
        left: '60%',
        height: '26px',
        width: '60px',
        zIndex: 2,
        backgroundColor: '#e2e2e2',
        border: '1px solid #aaaaaa',
        opacity: 0.8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        fontSize: '20px',
        borderRadius: '4px',
        [theme.breakpoints.down('xs')]: {
           height: '22px',
           width: '50px',
           fontSize: '16px',
        },
    },
    editCoverDiv: {
        position: 'absolute',
        bottom: '0%',
        right: '0%',
        height: '26px',
        borderRadius: '4px',
        width: '60px',
        border: '1px solid #aaaaaa',
        zIndex: 2,
        backgroundColor: '#e2e2e2',
        opacity: 0.8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        fontSize: '20px',
        [theme.breakpoints.down('xs')]: {
            height: '22px',
            width: '50px',
            fontSize: '16px',
        },
    },
    imageIcon: {
        color: '#686868',
        '&:hover': {
            cursor: 'pointer',
            transform: 'scale(1.1,1.1)',
        },
    },
    closeProfileBtn: {
        position: 'absolute',
        top: '0%',
        right: '0%',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#e2e2e2',
        borderRadius: '4px',
        boxSizing: 'border-box',
        opacity: 0.6,
    },
    closeIcon: {
        fontSize: '30px',
        padding: '6px 10px',
        color: '#888888',
        textShadow: '0px 0px 2px #e2e2e2',
        //textShadow: '-1px -1px 0 #888888, 1px -1px 0 #888888, -1px 1px 0 #888888, 1px 1px 0 #888888',
        '&:hover': {
            cursor: 'pointer',
            transform: 'scale(1.1,1.1)',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '24px',
            padding: '2px 6px',
        },
    },
    zoomCoverDiv: {
        display: 'none',
        position: 'absolute',
        width: '96%',
        maxHeight: '70vh',
        overflow: 'hidden',
        left: '50%',
        alignItems: 'center',
        boxSizing: 'border-box',
        transform: 'translate(-50%,-50%)',
        boxShadow: '0px 0px 8px #888888',
        zIndex: 100,
        border: '6px solid #e2e2e2',
        borderRadius: '4px',
    },
    zoomAvatarDiv: {
        display: 'none',
        position: 'absolute',
        width: '50vw',
        overflow: 'hidden',
        height: '50vw',
        boxSizing: 'border-box',
        boxShadow: '0px 0px 8px #888888',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        minWidth: '200px',
        maxWidth: '250px',
        minHeight: '200px',
        maxHeight: '250px',
        zIndex: 100,
        border: '6px solid #e2e2e2',
        borderRadius: '4px',
    },
    zoomCover: {
        width: '100%',
        //height: '100%',
        objectFit: 'cover',
    },
    zoomAvatar: {
        width: '100%',
        //height: '100%',
        objectFit: 'cover',
    },
    coverProgressDiv: {
        position: 'absolute',
        width: '200px',
        //backgroundColor: 'red',
        left: '50%',
        top: '50%',
        zIndex: 20,
        maxWidth: '40%',
        
        transform: 'translate(-50%,-50%)',
        maxWidth: '80%',
        [theme.breakpoints.down('sm')]: {
            width: '140px',
        },
    },
    imageProgressDiv: {
        position: 'absolute',
        width: '100px',
        
        zIndex: 20,
        //backgroundColor: 'red',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%,-50%)',
        maxWidth: '80%',
        [theme.breakpoints.down('sm')]: {
            width: '60px',
        },
    },
}))

